<mat-dialog-actions class="justify-content-between">
    <h3 *ngIf="isEdit">{{ 'LABEL.UPDATE_LABEL' | translate }} {{ 'ENTITY.TEMPLATE' | translate }}</h3>
    <h3 *ngIf="!isEdit">{{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.TEMPLATE' | translate }}</h3>
    <button mat-icon-button mat-dialog-close class="d-flex justify-content-center">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
</mat-dialog-actions>
<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="templateForm">
        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.TEMPLATE_NAME' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'LABEL.TEMPLATE_NAME' | translate }}"
                        formControlName="templateName" maxlength="100" />
                    <mat-error *ngIf="templateForm.get('templateName')?.hasError('required') && 
                    (templateForm.get('templateName')?.dirty || templateForm.get('templateName')?.touched)">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                    <mat-error *ngIf="templateForm.get('templateName')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM100' | translate }}
                    </mat-error>
                    <mat-error *ngIf="templateForm.get('templateName')?.hasError('minlength')">
                        {{ 'REQUIRED.MINIMUM3' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.TEMPLATE_DESCRIPTION' | translate }}</mat-label>
                    <textarea matInput placeholder="{{ 'LABEL.TEMPLATE_DESCRIPTION' | translate }}"
                        formControlName="templateDescription" rows="4" maxlength="500"></textarea>
                    <mat-error
                        *ngIf="templateForm.get('templateDescription')?.hasError('required') && 
                    (templateForm.get('templateDescription')?.dirty || templateForm.get('templateDescription')?.touched)">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                    <mat-error *ngIf="templateForm.get('templateDescription')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM500' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

    </form>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions>
    <div class="row m-t-4 p-r-16">
        <div class="col-lg-8"></div>
        <div class="col-lg-4 d-flex justify-content-end">
            <button mat-stroked-button type="button" class="m-r-5" (click)="onCloseDialog()">{{ 'BUTTON.BTN_CLOSE' |
                translate
                }}</button>

            <button mat-flat-button type="button" color="primary" class=" m-l-4" (click)="onAddTemplate()"
                [disabled]="templateForm.invalid || isLoading" *ngIf="!isEdit">
                {{ 'BUTTON.BTN_SAVE' | translate }}</button>
            <button mat-flat-button type="button" color="primary" class=" m-l-4" (click)="onUpdateTemplate()"
                [disabled]="templateForm.invalid || isLoading" *ngIf="isEdit">
                {{ 'BUTTON.BTN_SAVE' | translate }}</button>
        </div>
    </div>
</mat-dialog-actions>